import React, { useEffect, useRef, useState } from 'react';

const WhatWeDo = () => {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const currentRef = sectionRef.current;
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.3 }
    );

    if (currentRef) {
      observer.observe(currentRef);
    }

    return () => {
      if (currentRef) {
        observer.unobserve(currentRef);
      }
    };
  }, []);

  return (
    <section 
      ref={sectionRef}
      className="relative min-h-screen bg-white text-black py-32 px-6 md:px-12 overflow-hidden"
    >
      {/* Section Header Image - Full Width */}
      <div 
        className="relative w-full h-[500px] mb-16 overflow-hidden rounded-2xl shadow-2xl"
        style={{
          opacity: isVisible ? 1 : 0,
          transform: isVisible ? 'scale(1)' : 'scale(1.05)',
          transition: 'opacity 1s ease-out, transform 1s ease-out'
        }}
      >
        <img
          src="https://images.pexels.com/photos/7433840/pexels-photo-7433840.jpeg"
          alt="From systems to skills"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-black/10 to-transparent"></div>
        <div className="absolute bottom-12 left-12 right-12">
          <h2 className="text-5xl md:text-7xl lg:text-8xl font-bold tracking-tight text-white">
            From systems to skills
          </h2>
        </div>
      </div>

      <div className="container mx-auto max-w-6xl relative z-10">
        {/* AI Solutions Block with Image */}
        <div 
          className="mb-24 grid grid-cols-1 lg:grid-cols-2 gap-12 items-center"
          style={{
            opacity: isVisible ? 1 : 0,
            transform: isVisible ? 'translateY(0)' : 'translateY(30px)',
            transition: 'opacity 0.8s ease-out 0.2s, transform 0.8s ease-out 0.2s'
          }}
        >
          <div>
            <h3 className="text-3xl md:text-4xl font-bold mb-4">
              AI Solutions
            </h3>
            <p className="md:text-2xl !text-3xl text-gray-700">
              We develop custom AI and machine learning systems designed for reliability, maintainability, and real-world impact — not prototypes that stay in the lab.
            </p>
          </div>
          <div className="relative h-[400px] overflow-hidden rounded-2xl shadow-2xl">
            <img
              src="https://images.unsplash.com/photo-1580795479225-c50ab8c3348d"
              alt="Professional working at operations center"
              className="w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/10 to-transparent"></div>
          </div>
        </div>

        {/* AI Education Block with Image */}
        <div 
          className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center"
          style={{
            opacity: isVisible ? 1 : 0,
            transform: isVisible ? 'translateY(0)' : 'translateY(30px)',
            transition: 'opacity 0.8s ease-out 0.4s, transform 0.8s ease-out 0.4s'
          }}
        >
          <div className="relative h-[400px] overflow-hidden rounded-2xl shadow-2xl order-2 lg:order-1">
            <img
              src="https://images.unsplash.com/photo-1565688527174-775059ac429c"
              alt="Professional training collaboration"
              className="w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/10 to-transparent"></div>
          </div>
          <div className="order-1 lg:order-2">
            <h3 className="text-3xl md:text-4xl font-bold mb-4">
              AI Education
            </h3>
            <p className="md:text-2xl !text-3xl text-gray-700">
              We deliver practical AI training in automation, machine learning, and data-driven optimisation, taught by practitioners with long-standing real-world experience.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhatWeDo;